import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Info-filled-blue",
  "use": "icon-Info-filled-blue-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-Info-filled-blue\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm1-15.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM12 12h-2v-2h2a2 2 0 0 1 2 2v6h-2v-6Z\" fill=\"#4066D4\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol